export enum SlidersPerView {
  Auto = 'auto',
  ExtraSmall = 1,
  NewsBannerMobile = 1.465,
  ExtremeSmall = 1.5,
  MediumExtraSmall = 2,
  ExtraLarge = 2.7,
  NearMediumExtraSmall = 1.7,
  MediumSmall = 3,
  Mobile = 3.057,
  HalfMediumSmall = 3.5,
  Standard = 4,
  Small = 5,
  Medium = 6,
  ExtraMedium = 7,
  Large = 8,
}

export enum SpaceBetweenSwiper {
  Zero = 0,
  Small = 8,
  Medium = 15,
  Large = 16,
  xlLarger = 25,
  XxlLarger = 30,
}
